import { ITeamPlayersTable } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const TeamPlayersWrapper = React.lazy(() => import('./team-players'));
export interface IDynamicTeamPlayers extends IComponentModel<ITeamPlayersTable> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicTeamPlayers = ({
  /* istanbul ignore next: default value */ model = {} as ITeamPlayersTable,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicTeamPlayers) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <TeamPlayersWrapper
      live={live}
      initialModel={validateModel(model) as ITeamPlayersTable}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicTeamPlayers;
